// Generated by scripts/write-augmented-stone-flicking-replay-fixtures.ts.
// Do not edit manually.

import type { AsfReplayEventType } from "./event-adapter";

export interface AsfReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface AsfReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: AsfReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface AsfReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "augmented-stone-flicking";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly AsfReplayFixturePlayer[];
  readonly events: readonly AsfReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const AUGMENTED_STONE_FLICKING_REPLAY_FIXTURES: Record<
  string,
  AsfReplayFixture
> = {
  "simple-2p-live": {
    schemaVersion: 1,
    gameType: "augmented-stone-flicking",
    scenario: "simple-2p-live",
    source: "generated",
    capturedAt: "2026-06-08T00:00:00.000Z",
    players: [
      {
        id: "P1",
        name: "Player 1",
        role: "host",
      },
      {
        id: "P2",
        name: "Player 2",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "P1",
        payload: {
          state: {
            phase: "PLAYING",
            coreState: {
              phase: "INPUT_PHASE",
              round: 1,
              participants: [
                {
                  id: "P1",
                  name: "Player 1",
                },
                {
                  id: "P2",
                  name: "Player 2",
                },
              ],
              eliminatedParticipants: [],
              pendingInputs: {},
              submittedParticipants: [],
              entities: [
                {
                  id: "p0-stone-1",
                  archetype: "STONE",
                  owner: "P1",
                  x: 7.3,
                  y: 7.3,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p0-stone-2",
                  archetype: "STONE",
                  owner: "P1",
                  x: 2.7,
                  y: 7.3,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p0-stone-3",
                  archetype: "STONE",
                  owner: "P1",
                  x: 6.77,
                  y: 6.77,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p0-stone-4",
                  archetype: "STONE",
                  owner: "P1",
                  x: 5.65,
                  y: 7.41,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p0-stone-5",
                  archetype: "STONE",
                  owner: "P1",
                  x: 4.35,
                  y: 7.41,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p0-stone-6",
                  archetype: "STONE",
                  owner: "P1",
                  x: 3.23,
                  y: 6.77,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p1-stone-1",
                  archetype: "STONE",
                  owner: "P2",
                  x: 2.7,
                  y: 2.7,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p1-stone-2",
                  archetype: "STONE",
                  owner: "P2",
                  x: 7.3,
                  y: 2.7,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p1-stone-3",
                  archetype: "STONE",
                  owner: "P2",
                  x: 3.23,
                  y: 3.23,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p1-stone-4",
                  archetype: "STONE",
                  owner: "P2",
                  x: 4.35,
                  y: 2.59,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p1-stone-5",
                  archetype: "STONE",
                  owner: "P2",
                  x: 5.65,
                  y: 2.59,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
                {
                  id: "p1-stone-6",
                  archetype: "STONE",
                  owner: "P2",
                  x: 6.77,
                  y: 3.23,
                  radius: 0.35,
                  mass: 1,
                  eliminated: false,
                },
              ],
              winner: null,
              outcomeReason: null,
              isDraw: false,
              lastRecording: null,
              hostPlayerId: "P1",
            },
            round: 1,
            playerCount: 2,
            eliminatedPlayers: [],
            submittedPlayers: [],
            winner: null,
            isDraw: false,
          },
          config: {
            board: {
              centerX: 5,
              centerY: 5,
              radius: 5,
              boundaryPadding: 0.3,
            },
            dynamics: {
              timeStep: 0.016666666666666666,
              frictionCoefficient: 3,
              velocityThreshold: 0.01,
              minImpulseMagnitude: 0.1,
              restitutionCoefficient: 0.8,
              maxSimulationSteps: 600,
            },
            accuracy: {
              power: {
                min: 0.8,
                max: 0.95,
              },
              direction: {
                min: 0.8,
                max: 0.95,
              },
              directionMaxErrorDeg: 15,
            },
            pieces: [
              {
                archetype: "STONE",
                radius: 0.35,
                mass: 1,
              },
            ],
            deployment: {
              seeds: [
                {
                  id: "p0-stone-1",
                  archetype: "STONE",
                  ownerIndex: 0,
                  x: 7.3,
                  y: 7.3,
                },
                {
                  id: "p0-stone-2",
                  archetype: "STONE",
                  ownerIndex: 0,
                  x: 2.7,
                  y: 7.3,
                },
                {
                  id: "p0-stone-3",
                  archetype: "STONE",
                  ownerIndex: 0,
                  x: 6.77,
                  y: 6.77,
                },
                {
                  id: "p0-stone-4",
                  archetype: "STONE",
                  ownerIndex: 0,
                  x: 5.65,
                  y: 7.41,
                },
                {
                  id: "p0-stone-5",
                  archetype: "STONE",
                  ownerIndex: 0,
                  x: 4.35,
                  y: 7.41,
                },
                {
                  id: "p0-stone-6",
                  archetype: "STONE",
                  ownerIndex: 0,
                  x: 3.23,
                  y: 6.77,
                },
                {
                  id: "p1-stone-1",
                  archetype: "STONE",
                  ownerIndex: 1,
                  x: 2.7,
                  y: 2.7,
                },
                {
                  id: "p1-stone-2",
                  archetype: "STONE",
                  ownerIndex: 1,
                  x: 7.3,
                  y: 2.7,
                },
                {
                  id: "p1-stone-3",
                  archetype: "STONE",
                  ownerIndex: 1,
                  x: 3.23,
                  y: 3.23,
                },
                {
                  id: "p1-stone-4",
                  archetype: "STONE",
                  ownerIndex: 1,
                  x: 4.35,
                  y: 2.59,
                },
                {
                  id: "p1-stone-5",
                  archetype: "STONE",
                  ownerIndex: 1,
                  x: 5.65,
                  y: 2.59,
                },
                {
                  id: "p1-stone-6",
                  archetype: "STONE",
                  ownerIndex: 1,
                  x: 6.77,
                  y: 3.23,
                },
              ],
            },
            maxTurns: 50,
            playerCount: 2,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "action",
        userId: "P1",
        payload: {
          type: "SUBMIT_FLICK",
          playerId: "P1",
          entityId: "p0-stone-1",
          impulse: {
            x: 1.1,
            y: 0.2,
          },
        },
      },
      {
        sequenceNumber: 3,
        eventType: "action",
        userId: "P2",
        payload: {
          type: "SUBMIT_FLICK",
          playerId: "P2",
          entityId: "p1-stone-1",
          impulse: {
            x: -1.1,
            y: -0.2,
          },
        },
      },
      {
        sequenceNumber: 4,
        eventType: "action",
        userId: "P1",
        payload: {
          type: "RESOLVE_ROUND",
          resolverId: "P1",
          randomSeed: 24680,
        },
      },
      {
        sequenceNumber: 5,
        eventType: "action",
        userId: "P2",
        payload: {
          type: "SURRENDER",
          playerId: "P2",
        },
      },
    ],
    notes: [
      "Augmented Stone Flicking is treated as public-information for v2 projection; replay renders canonical engine state directly.",
      "Fixture: init -> two SUBMIT_FLICK commands -> seeded RESOLVE_ROUND (24680) -> SURRENDER to reach GAME_END.",
      "Final state: phase GAME_END, winner P1.",
    ],
  },
};
